export const deliverabilitySndsAppGroupIdIps = "/deliverability/snds/:app_group_id/ips";
